/* eslint-disable no-prototype-builtins,no-eval */
import VueCookie from 'vue-cookie'

export default {
  /**
   * Run deactivation Script of every cookie listed in given list
   * @param cookieList
   */
  invalidateCookieJsByList (cookieList) {
    for (const cookieIndex in cookieList) {
      if (cookieList.hasOwnProperty(cookieIndex)) {
        const cookie = cookieList[cookieIndex].cookie

        if (cookie === undefined) {
          continue
        }

        if (cookie.hasOwnProperty('jsCodeDeactivate')) {
          // eslint-disable-next-line no-eval
          eval(cookie.jsCodeDeactivate)
        }
      }
    }
  },
  /**
   * Clear all Cookies from given List
   * @param cookieList
   */
  clearCookieByList (cookieList) {
    for (const cookieIndex in cookieList) {
      if (cookieList.hasOwnProperty(cookieIndex)) {
        const cookieToDelete = cookieList[cookieIndex]
        if (cookieToDelete.hasOwnProperty('cookie')) {
          this.deleteCookie(cookieToDelete.cookie.name)
        }
      }
    }
  },
  /**
   * Set all cookies from given List
   * @param cookieList
   */
  addCookieByList (cookieList) {
    for (const cookieIndex in cookieList) {
      if (cookieList.hasOwnProperty(cookieIndex)) {
        const checkedCookie = cookieList[cookieIndex]
        if (checkedCookie.hasOwnProperty('cookie')) {
          this.addCookie(
            checkedCookie.cookie.name,
            checkedCookie.cookie.value,
            checkedCookie.cookie.expirationUnit,
            checkedCookie.cookie.expiresIn
          )
        }
        if (checkedCookie.cookie.hasOwnProperty('jsCodeActivate')) {
          eval(checkedCookie.cookie.jsCodeActivate)
        } else {
          if (checkedCookie.hasOwnProperty('jsCodeDeactivate')) {
            eval(checkedCookie.jsCodeDeactivate)
          }
        }
      }
    }
  },
  /**
   * Core Logic to add a cookie on Browser.
   * @param name, name of cookie
   * @param value, cookie data
   * @param expirationUnit, unit of expiration
   * @param expiresIn, expiration value
   */
  addCookie (name, value, expirationUnit, expiresIn) {
    const date = new Date()

    if (expirationUnit && expiresIn > 0) {
      const calculateTime = {
        hour: ((expiresIn) * 60 * 60 * 1000),
        day: (expiresIn * 24 * 60 * 60 * 1000),
        month: ((expiresIn * 24 * 60 * 60 * 1000) * 30),
        year: ((expiresIn * 24 * 60 * 60 * 1000) * 365)
      }
      date.setTime(date.getTime() + calculateTime[expirationUnit])
    }

    // Add new Cookie
    if (document.cookie.indexOf(name) === -1) {
      VueCookie.set(
        name,
        value,
        {
          expires: date,
          path: '/'
        })
    }
  },
  /**
   * Check if Cookie is present in Local Storage
   * @param name
   * @return {boolean}
   */
  isCookieExisting (name) {
    return document.cookie.indexOf(name) !== -1
  },
  /**
   * Delete single Cookie
   * @param cookieName
   */
  deleteCookie (cookieName) {
    if (this.isCookieExisting(cookieName)) {
      VueCookie.delete(cookieName, { path: '/' })
    }
  }
}
